import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FdUnauthenticatedCardComponent } from '../shared/fd-unauthenticated-card/fd-unauthenticated-card.component';
import { AuthService } from '../../services/auth.service';
import { initPopupData } from '../../model/popup-data';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatDialogContent,
    MatDialogClose,
    MatDialogActions,
    MatButtonModule,
    FdUnauthenticatedCardComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  passwordResetSent: boolean = false;
  titleText = 'Forgot your password?';
  subTitleText = 'Enter your email address to reset password.';
  buttonText = 'Reset Password';
  email = new FormControl('', [
    Validators.required,
    Validators.minLength(3),
    Validators.email,
  ]);
  popupdata = initPopupData;
  isDarkMode: boolean = false

  constructor(private authService: AuthService, public dialog: MatDialog
    , private utilities: UtilitiesService,
  ) { }

  ngOnInit() {
    this.isDarkMode = localStorage.getItem('theme') === 'theme-dark';
  }

  forgotPassword() {
    this.authService.forgotPassword(this.email.value)
      .subscribe({
        next: (res: any) => {
          if (res.message) {
            this.passwordResetSent = true;
            this.titleText = 'Please check your email.';
            this.subTitleText =
              'A password reset link has been sent to your inbox.';
            this.buttonText = 'Resend';
          }
        },
        error: (err: any) => {
          if (err.error && err.error.message) {
            this.popupdata.title = "Failed";
            this.popupdata.content = err.error.message;
            this.popupdata.warn = true;
          }
          else {
            this.popupdata.title = "Failed";
            this.popupdata.content = "Error Encountered. Please try again later.";
            this.popupdata.warn = true;
          }
          this.utilities.notifPopup(this.popupdata);
        }
      }
      );
  }
}
